<template>
  <HeaderTitle>
    <template #top>{{ t("code.scan.screen.title") }}</template>
    <template #bottom>{{ t("code.web.subtitle") }}</template>
  </HeaderTitle>

  <div>
    <h2 class="text-large">{{ t("registration.web.laststep.title") }}</h2>
  </div>

  <div
    class="flex flex-col justify-center items-center mt-4 gap-4 w-96 mx-auto"
  >
    <div class="mb-4 whitespace-pre-line">
      {{ t("registration.web.laststep.body") }}
    </div>
    <BaseButton variant="primary" @click="$emit('redirectToLogin')"
      >Login</BaseButton
    >
  </div>
</template>

<script setup lang="ts">
import BaseButton from "../layout/button/BaseButton.vue";
import { useI18n } from "vue-i18n";
import HeaderTitle from "../layout/header/HeaderTitle.vue";

const { t } = useI18n();

defineProps({
  open: Boolean,
});

defineEmits(["redirectToLogin", "change-view"]);
</script>
